import {useAuthStore} from "~/stores/auth/index.js";

export const useRBAC = () => {
    const authStore = useAuthStore()


    // Permissions
    const hasPermission = (permission) => {
        return authStore.hasPermission(permission)
    }

    const hasAnyPermission = (permissions) => {
        return permissions.some(permission => hasPermission(permission))
    }

    const hasAllPermissions = (permissions) => {
        return permissions.every(permission => hasPermission(permission))
    }

    // Roles RBAC
    const canManageRoles = () => {
        return hasPermission('role_manage') || hasPermission('manage_all')
    }

    const canCreateRole = () => {
        return hasPermission('role_create') || canManageRoles()
    }

    const canUpdateRole = () => {
        return hasPermission('role_update') || canManageRoles()
    }

    const canReadRole = () => {
        return hasPermission('role_read') || canManageRoles()
    }

    // Users RBAC
    const canManageUsers = () => {
        return hasPermission('user_manage') || hasPermission('manage_all')
    }

    const canCreateUser = () => {
        return hasPermission('user_create') || canManageUsers()
    }

    const canUpdateUser = () => {
        return hasPermission('user_update') || canManageUsers()
    }

    const canReadUser = () => {
        return hasPermission('user_read') || canManageUsers()
    }

    // Quote RBAC
    const canManageQuotes = () => {
        return hasPermission('quote_manage') || hasPermission('manage_all')
    }

    const canAnswerQuote = () => {
        return hasPermission('quote_answer') || canManageQuotes()
    }

    const canUpdateQuote = () => {
        return hasPermission('quote_update') || canManageQuotes()
    }

    const canReadQuote = () => {
        return hasPermission('quote_read') || canManageQuotes()
    }


    return {
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
        canManageRoles,
        canCreateRole,
        canUpdateRole,
        canReadRole,
        canManageUsers,
        canCreateUser,
        canUpdateUser,
        canReadUser,
        canManageQuotes,
        canAnswerQuote,
        canUpdateQuote,
        canReadQuote,
    }
}